function validate(){
  var found = true;
  var options = document.getElementsByClassName("single-option-selector");
  options.forEach(function(item, index) {
      if(!item.value){
       found = false;
      }
  });
  return found;
}
var selects = document.getElementsByClassName("single-option-selector");
selects.forEach(function(item, index) {
  	  for (i = 0; i < item.options.length; ++i){
          if (item.options[i].value == "Regular Fit" || item.options[i].value == "Jersey Number" || name == "Initials"){
            item.options[i] = null;
          }
      }
  });

var selects = document.getElementsByClassName("product-form__variants");
selects.forEach(function(item, index) {
  	  for (i = 0; i < item.options.length; ++i){
          var name = (item.options[i].text).replace("Regular Fit - Sold out", "Regular Fit");
          if (name == "Regular Fit" || name == "Jersey Number" || name == "Initials"){
            
            //item.options[i] = null;
          }
      }
  });

function removeItem(url){
	return false;
}